import './App.css';
import ContextProvider from './context/AppContext'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NavBar from './components/NavBar'
import { ThemeProvider } from '@material-ui/core'
import theme from './styles/mainTheme';
import AlteraCadastro from './pages/AlteraCadastro';

function App() {
    return (
        <ContextProvider>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <div className="App">
                        <NavBar />
                        <Switch>
                            <Route path="/" component={AlteraCadastro} />
                        </Switch>
                    </div>
                </BrowserRouter>
            </ThemeProvider>
        </ContextProvider>


    );
}

export default App;
